import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, DatePicker, Form, InputNumber, notification} from 'antd';
import moment from "moment";

import {getFee, addFeeRate} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {bindActionCreators} from "redux";
import {formItemLayout} from "../utils/style";
import {decodeParams} from "../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddFeeRateForm extends Component {
  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.feeId !== prevProps.match.params.feeId) this._load();
  }

  _load() {
    const {feeId} = decodeParams(this.props.match.params);
    this.props.getFee({feeId});
  }

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    const {feeId} = decodeParams(this.props.match.params);
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        const effectiveDate = moment(values.effectiveDate).startOf('day');
        await this.props.addFeeRate({...values, effectiveDate, feeId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, fee} = this.props;
    return (
      <Card title="Update Fee Rate">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Fee"
          >
            {fee.name}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Flat rate"
          >
            {getFieldDecorator('flatRate', {
              rules: [{
                required: true,
                message: 'Flat rate is required'
              }, {
                type: 'number',
                min: 0,
                message: 'Flat rate must be greater than or equal to zero'
              }]
            })(
              <InputNumber precision={2} step={0.01} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="Effective Date"
          >
            {getFieldDecorator('effectiveDate', {
              rules: [{
                required: true,
                message: 'Effective date is required'
              }]
            })(
              <DatePicker format="YYYY-MM-DD HH:mm:ss" showTime={{defaultValue:moment('00:00:00','HH:mm:ss')}} />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Update Fee Rate
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

AddFeeRateForm.propTypes = {
  form: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  addFeeRate: PropTypes.func.isRequired,
  getFee: PropTypes.func.isRequired,
  fee: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

const AddFeeRatePage = Form.create()(AddFeeRateForm);

const mapStateToProps = state => ({
  fee: state.fee.fee || {},
  loading: state.fee.feeLoading || state.fee.addingFeeRate,
});

const mapDispatchToProps = dispatch => ({
  addFeeRate: bindActionCreators(addFeeRate, dispatch),
  getFee: bindActionCreators(getFee, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddFeeRatePage);



// WEBPACK FOOTER //
// ./src/Fee/AddFeeRatePage.js